<template>
  <v-container id="registrationPage">
    <div id="new-account" @keyup.enter="handleSubmit">
      <h1>Welcome to Telemonial!</h1>
      <br />
      <h3>Create your new account</h3>
      <br />
      <p class="text-center red--text">
        {{ errorMsg }}
      </p>
      <v-form ref="registration" v-model="isValid">
        <v-text-field
          v-model="input.email"
          type="email"
          class="rounded-0 darken-1"
          :rules="[rules.required, rules.validEmail]"
          name="email"
          placeholder="Email Address"
        /><br />
        <v-text-field
          v-model="input.username"
          type="text"
          class="rounded-0 darken-1"
          :rules="[rules.required, rules.validUsername, rules.max_length]"
          name="username"
          placeholder="Username"
        /><br />
        <v-text-field
          v-model="input.password"
          type="password"
          name="password"
          :rules="[rules.required, rules.password_max, rules.password_min]"
          placeholder="Password"
          @input="validateConfirmation"
        />
        <v-text-field
          v-model="input.confirmPassword"
          type="password"
          name="confirm-password"
          :rules="[rules.required, rules.passwordMatches]"
          placeholder="Confirm Password"
        />

        <v-checkbox v-model="input.acceptTerms" :rules="[rules.required]">
          <template v-slot:label>
            <span>
              I have read and accept the
              <a href="https://telemonial.com/privacy-policy" target="_blank" @click.stop>Privacy Policy</a>
              and the
              <a href="https://telemonial.com/terms-and-conditions" target="_blank" @click.stop
                >Terms and Conditions of Use.</a
              >
            </span>
          </template>
        </v-checkbox>

        <div style="text-align: center">
          <v-btn @click="handleSubmit" :disabled="!isValid" large rounded color="primary"> Create Account </v-btn>
        </div>
        <div class="text-center mt-3">
          Already have an account?
          <router-link :to="{ name: 'login' }">Log in here</router-link>
        </div>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "CreateAccountPage",

  metaInfo: {
    title: "Create an Account",
  },

  components: {},
  data: function () {
    return {
      isValid: false,
      errorMsg: "",
      input: {
        username: "",
        password: "",
        confirmPassword: "",
        email: "",
        acceptTerms: false,
      },
      rules: {
        required: (val) => val === true || val.length > 0 || "Required",
        max_length: (val) => val.length <= 32 || "Username must be 32 characters or less",
        passwordMatches: (val) => val === this.input.password || "Passwords don't match",
        password_min: (val) => val.length >= 8 || "Password must be 8 chars or more",
        password_max: (val) => val.length <= 128 || "Password too long. Max 128 characters",
        validEmail: (val) => {
          //regex grabbed from emailregex.com to match email addresses. Removed 2 "unnecessary escapes"--watch for bugs.
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return regex.exec(val) !== null || "Invalid Email";
        },
        validUsername: (val) => {
          const regex = /^[A-Za-z0-9_\-.]+$/;
          return regex.exec(val) !== null || "Username contains invalid characters";
        },
      },
    };
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    validateConfirmation: function () {
      if (this.input.confirmPassword !== "") {
        this.$refs.registration.validate();
      }
    },
    handleSubmit: function () {
      if (!this.$refs.registration.validate()) {
        return;
      }
      this.$axios
        .post("/create-account", {
          username: this.input.username,
          password: this.input.password,
          email: this.input.email,
        })
        .then(() => {
          console.log("Account Created");
          this.login();
        })
        .catch((err) => {
          console.log(err);
          this.errorMsg = err.response.data.message;
        });
    },
    login() {
      if (this.input.username !== "" && this.input.password !== "") {
        this.$axios
          .post("/login", {
            username: this.input.username,
            password: this.input.password,
          })
          .then((response) => {
            let jsonToken = response.data;
            document.cookie = "authorization=" + jsonToken + "; SameSite=Strict";
            this.$store.commit("login", { authorization: jsonToken });
            this.$axios.defaults.headers.common["Authorization"] = `Bearer ${jsonToken}`;
            console.log("Rerouting");
            this.$router.push({ name: "home" });
          })
          .catch(() => {
            // TODO: Distinguish if username already in use
            this.showSnackbar({
              text: "An error occurred",
              error: true,
            });
          });
      } else {
        console.log("A username and password must be present");
      }
    },
  },
};
</script>

<style scoped>
#registrationPage {
  display: flex;
  align-items: center;
  min-height: 90vh;
}
#new-account {
  width: 500px;
  max-width: 90%;
  border: 1px solid var(--v-divider-base);
  background-color: var(--v-card-base);
  margin: auto;
  padding: 20px;
}
</style>
